import axios from "axios";

// A dedicated axios instance for the Cleaning Audit module, pointed directly at
// the real Cleaning Audit API (REACT_APP_CA_API_URL) — the same host
// MajesticERP-CleaningAuditWeb/code/server itself forwards to
// (config_setting.cleaning_audit_api). That Node server added nothing but a
// same-origin relay (see server/utils/serverUtils.js's getRequiredHeadersFromRequest:
// a straight header passthrough, no auth logic of its own), so per our own
// convention of calling our real backend directly (src/utils/apiCall.js ->
// REACT_APP_API_URL), we skip that hop entirely rather than standing up a second
// proxy layer just for this module.
//
// This deliberately does NOT share MyM's own client (src/utils/interceptors/axios.js)
// or its errorInterceptor, which clears localStorage and redirects to /login on
// any 401+ — a Cleaning-Audit-only auth hiccup must never log the whole app out.
const cleaningAuditClient = axios.create({
  baseURL: process.env.REACT_APP_CA_API_URL,
  headers: {
    "content-type": "application/json",
    accept: "application/json",
  },
});

export default cleaningAuditClient;
